import React from 'react';
import {loadModules} from 'esri-loader';
import satTrack from '../../resources/satTrack'

const HomeButton = (props) => {
    const initHome = async () => {
        const [Home] = await loadModules(['esri/widgets/Home']);
        const home = new Home({view: props.view});
        home.goToOverride = async (view, goToParams) => {
            const oldcenter = view.center;
            const $mapPoint = props.initalFeature.geometry.extent.center;
            props.passSearchPoint(
                $mapPoint,
                props.onValidSearch,
                props.onInvalidSearch
            );
            satTrack('map_home_button', {orig_center: [oldcenter.latitude, oldcenter.longitude], target_center:[$mapPoint.latitude, $mapPoint.longitude], Description:'Home Button Press'})
        };
        props.view.ui.add(home, {
            position: 'top-right'
          });

    };
    React.useEffect(() => {
        if (props.initalFeature && props.view) {
            initHome();
        }

    }, [props.initalFeature, props.view]);

return (
        <div>

        </div>
    );
};

export default HomeButton;
